import Image, { ImageProps } from "next/image";

type Props = {
  fields: any;
  src?: string;
  className?: string;
} & Omit<ImageProps, 'src'>

const normalizeImageUrl = (value: unknown) => {
  if (typeof value !== "string") {
    return "";
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return "";
  }

  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return trimmed;
  }

  if (trimmed.startsWith("//")) {
    return `https:${trimmed}`;
  }

  if (trimmed.startsWith("/")) {
    return trimmed;
  }

  return `/${trimmed}`;
};

export default function CImage ({ fields: entry, ...rest}: Props) {
  const fields = entry?.fields;
  const file = fields?.file;
  const imageUrl = normalizeImageUrl(file?.url);

  // Unresolved / unpublished Contentful assets arrive without fields.file -
  // render nothing rather than crashing the whole page build.
  if (!imageUrl) {
    return null;
  }

  const alt = fields?.title || file?.fileName || "";
  const fillSizes =
    rest.fill && !rest.sizes
      ? "(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 640px"
      : rest.sizes;

  return (
    <Image
      src={imageUrl}
      alt={alt}
      placeholder='blur'
      blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAwIiBoZWlnaHQ9IjQ3NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiLz4="
      {...rest}
      sizes={fillSizes}
      style={{
        maxWidth: "100%",
        // height: "auto"
      }} />
  );
}
